<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    (matSortChange)="sortData($event)"
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--    name-->
    <ng-container matColumnDef="name"
                  sticky
    >
      <th
        *matHeaderCellDef
        id="name"
        mat-header-cell
        mat-sort-header
      >
        Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
          <span
            (click)="eachRow.status.key > userStatusMap.inProcess ?
             openUserDetails(eachRow) : {}"
            [class.clickable]="eachRow.status.key > userStatusMap.inProcess"
          >
            {{ eachRow.firstName }} {{ eachRow.lastName }}
          </span>
      </td>
    </ng-container>
    <!--    group-->
    <ng-container matColumnDef="group"
    >
      <th
        *matHeaderCellDef
        id="group"
        mat-header-cell
        mat-sort-header
      >
        Active Group Name
      </th>
      <td (click)="groupNameClick(eachRow)"
          *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem] clickable"
          mat-cell>
        {{ eachRow.group?.name }}
      </td>
    </ng-container>
    <!--    currentWeight-->
    <ng-container matColumnDef="currentWeight">
      <th
        *matHeaderCellDef
        id="currentWeight"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Current Weight (lbs)
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentWeight }}
      </td>
    </ng-container>
    <!--    weightChange-->
    <ng-container matColumnDef="weightChange"
    >
      <th
        *matHeaderCellDef
        id="weightChange"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Weight Change since baseline
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[18rem] min-w-[18rem]"
          mat-cell>
        {{ eachRow.weightChange }}
      </td>
    </ng-container>
    <!--    weightLossAlert-->
    <ng-container matColumnDef="weightLossAlert"
    >
      <th
        *matHeaderCellDef
        id="weightLossAlert"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px] flex items-center gap-[0.5rem]"
        >
          Safety Alert
          <span
            [matTooltip]="'2 recent measures show weight loss greater than 2 lbs/week.  Please check.'"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="below"
            style="display: inline-flex; align-items: center; cursor: pointer;"
          >
            <app-icon
              class="tooltip-icon"
              svgIcon="info"
              style="color: #59B3A9; width: 1.6rem; height: 1.6rem;"
            ></app-icon>
          </span>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[14rem] min-w-[14rem]"
          mat-cell>
        <app-icon
          *ngIf="eachRow.weightLossAlert"
          class="weight-loss-icon"
          svgIcon="alert"
        ></app-icon>
      </td>
    </ng-container>
    <!--    currentBMI-->
    <ng-container matColumnDef="currentBMI"
    >
      <th
        *matHeaderCellDef
        id="currentBMI"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Current BMI (kg/m<sup>2</sup>)
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentBMI }}
      </td>
    </ng-container>
    <!--    changeBmi-->
    <ng-container matColumnDef="changeBMI"
    >
      <th
        *matHeaderCellDef
        id="changeBMI"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Change in BMI (kg/m<sup>2</sup>)
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeBMI }}
      </td>
    </ng-container>
    <!--    currentMedianBmi-->
    <ng-container matColumnDef="currentMedianBMI"
    >
      <th
        *matHeaderCellDef
        id="currentMedianBMI"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Current Percent Over Median BMI
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentMedianBMI }}
      </td>
    </ng-container>
    <!--    changeMedianBmi-->
    <ng-container matColumnDef="changeMedianBMI"
    >
      <th
        *matHeaderCellDef
        id="changeMedianBMI"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Change in Percent Over Median BMI
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeMedianBMI }}
      </td>
    </ng-container>
    <!--    changeOverPercentile-->
    <ng-container matColumnDef="changeOverPercentile"
    >
      <th
        *matHeaderCellDef
        id="changeOverPercentile"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Change in Percent Over 95%ile BMI
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeOverPercentile }}
      </td>
    </ng-container>
    <ng-container matColumnDef="currentOverPercentile"
    >
      <th
        *matHeaderCellDef
        id="currentOverPercentile"
        mat-header-cell
        mat-sort-header
      >
        <div
          class="pl-[12px]"
        >
          Current Percent Over 95%ile BMI
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentOverPercentile }}
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
